import MapComponent from "components/MapComponent/MapComponent";
import asset from "json/assets";
import MapWrapper from "layout/MapWrapper/MapWrapper";
import styles from "styles/component/NoItemFound.module.scss";
import CustomButton from 'ui/CustomButton/CustomButton';

export default function NoDataAndDisconnected() {
 
  return (
    <MapWrapper title={'DRIVING RANGE'}>
      <div className={styles.match_wrap_full}>
        <div className={styles.match_wrap}>
          <i className={styles.srch_icon}>
            <img src={asset.nodata} alt="" />
          </i>
          <p className={styles.blue_txt}>No Data Available </p>
          <p className={styles.gray_txt}>Probably, device has been disconnected from the course </p>
          {/* <CustomButton>Cancel</CustomButton> */}
          {/* <Link to={"#"} className={styles.blue_btn}>
            Cancel
          </Link> */}
        </div>
      </div>
    </MapWrapper>
  );
}
